export default "__VITE_ASSET__pY$cp$xN__"